import clsx from "clsx";
import { resolveResponsiveProp } from "../../utils/resolveResponsiveProp.mjs";
import { preventCollapsePseudo, styles } from "./negativeMargin.css.mjs";
const negativeMargin = (direction, space) => space ? clsx([
  direction === "top" || direction === "bottom" ? preventCollapsePseudo[direction] : void 0,
  resolveResponsiveProp(
    space,
    styles[direction].mobile,
    styles[direction].tablet,
    styles[direction].desktop,
    styles[direction].wide
  )
]) : null;
export {
  negativeMargin
};
